import {useEffect, useId, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsPresignupAddEditStudentModal = (props: {
    active: boolean,
    closeHandler: any,
    studentId:number,
    onDone:any,
    edit:boolean,
}) => {
    const [firstname,setFirstname] = useState('');
    const [lastname,setLastname] = useState('');
    const [tell,setTell] = useState('');
    const [grade,setGrade] = useState('1');
    const [national,setNational] = useState('');
    const [birthSerial,setBirthSerial] = useState('');
    const [err,setErr] = useState({
        firstname:false,
        lastname:false,
        tell:false,
        grade:false,
        national:false,
        birthSerial:false,
    });
    const ids = {
        firstname:useId(),
        lastname:useId(),
        tell:useId(),
        grade:useId(),
        national:useId(),
        birthSerial:useId(),
    };
    const [sms,setSms] = useState(true);
    const fetchData = (studentId:number) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/get-for-edit',
            {
                id:studentId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname:string,
                lastname:string,
                national:string,
                grade:number,
                tell:string,
                birthSerial:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setFirstname(d.firstname);
                setLastname(d.lastname);
                setTell(d.tell.replaceAll('+98','0'));
                setGrade(d.grade.toString());
                setBirthSerial(d.birthSerial);
                setNational(d.national);
                setSms(false);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.edit;
        const studentId = props.studentId;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setSms(true);
            if(isEdit){
                fetchData(studentId);
            } else {
                setFirstname('');
                setLastname('');
                setTell('');
                setGrade('1');
                setNational('');
                setBirthSerial('');
            }
            setErr({
                firstname:false,
                lastname:false,
                tell:false,
                grade:false,
                national:false,
                birthSerial:false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const isEdit = props.edit;
        let data = {
            id:props.studentId.toString(),
            sms:sms ? '1' : '0',
            firstname:firstname.trim(),
            lastname:lastname.trim(),
            national:national.trim(),
            serial:birthSerial.trim(),
            grade:grade.trim(),
            tell:tell.trim(),
        };
        let errors = {
            firstname:false,
            lastname:false,
            tell:false,
            grade:false,
            national:false,
            birthSerial:false,
        };
        let stop = false;
        if(data.firstname.length < 2){
            stop = true;
            errors.firstname = true;
        }
        if(data.lastname.length < 2){
            stop = true;
            errors.lastname = true;
        }
        if(national.length < 5){
            stop = true;
            errors.national = true;
        }
        if(data.tell.length !== 11){
            stop = true;
            errors.tell = true;
        }
        if(data.serial.length < 3){
            stop = true;
            errors.birthSerial = true;
        }
        data.tell = '+98' + data.tell.substring(1);
        setErr(errors);
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/' + (isEdit ? 'edit':'add'),
            data,
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'national'){
                        setErr(v=>{
                            let x = {...v};
                            x.national = true;
                            return x;
                        });
                    }
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    isEdit ? 'مشخصات دانش‌آموز ویرایش شد.': 'دانش آموز جدید افزوده شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش دانش‌آموز' : 'افزودن دانش‌آموز'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.firstname} data-necessary="yes">نام:</label>
                        <input type="text"
                               id={ids.firstname}
                               className={"form-control" + (err.firstname ? ' is-invalid' : '')}
                               value={firstname}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setFirstname(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.firstname = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.firstname ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.lastname} data-necessary="yes">نام خانوادگی:</label>
                        <input type="text"
                               id={ids.lastname}
                               className={"form-control" + (err.lastname ? ' is-invalid' : '')}
                               value={lastname}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setLastname(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.lastname = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.lastname ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.national} data-necessary="yes">کدملی:</label>
                        <input type="text"
                               id={ids.national}
                               className={"form-control" + (err.national ? ' is-invalid' : '')}
                               value={national}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setNational(ToxicDigitsFixToEnglish(t));
                                   setErr(v => {
                                       let x = {...v};
                                       x.national = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.national ? ' d-block' : ' d-none')}>
                            کدملی وارد شده صحیح نمی‌باشد.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.tell} data-necessary="yes">تلفن همراه والد:</label>
                        <input type="tel"
                               id={ids.tell}
                               className={"form-control" + (err.tell ? ' is-invalid' : '')}
                               value={tell}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTell(ToxicDigitsFixToEnglish(t));
                                   setErr(v => {
                                       let x = {...v};
                                       x.tell = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.tell ? ' d-block' : ' d-none')}>
                            لطفا تلفن همراه را بصورت ۱۱ رقمی و با صفر اول وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.birthSerial} data-necessary="yes">سریال شناسنامه:</label>
                        <input type="text"
                               id={ids.birthSerial}
                               className={"form-control" + (err.birthSerial ? ' is-invalid' : '')}
                               value={birthSerial}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setBirthSerial(ToxicDigitsFixToEnglish(t));
                                   setErr(v => {
                                       let x = {...v};
                                       x.birthSerial = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.birthSerial ? ' d-block' : ' d-none')}>
                            سریال شناسنامه صحیح نمی‌باشد.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.grade} data-necessary="yes">پایه تحصیلی:</label>
                        <select id={ids.grade}
                                className={"form-control" + (err.grade ? ' is-invalid':'')}
                                value={grade}
                                onChange={e => {
                                    setGrade(e.currentTarget.value);
                                    setErr(v => {
                                        let x = {...v};
                                        x.grade = false;
                                        return x;
                                    });
                                }}>
                            {[1,2,3,4,5,6,7,8,9,10,11,12].map((g,i)=>
                                <option value={g.toString()} key={"J82SSX_sjSAQqq" + i}>{GradeToString(g)}</option>
                            )}
                        </select>
                        <div className={"invalid-feedback" + (err.grade ? ' d-block' : ' d-none')}>
                            لطفا یک پایه را انتخاب کنید.
                        </div>
                        {
                            !props.edit ?
                                <button className={"techaran-checkbox" + (sms ? ' active':'')}
                                        style={{marginTop:20}}
                                        onClick={()=>setSms(v=>!v)}>
                                    <i><CheckIcon/></i>
                                    <span>ارسال پیامک به والد</span>
                                </button> : null
                        }
                        <div className="d-flex justify-content-end align-items-center" style={{gap:5,marginTop:20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره اطلاعات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};